module.exports = __webpack_public_path__ + "img/jugend.4f4f72aa.jpg";